import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import {
  Input,
  ModalBody,
  ModalFooter,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap'
import { resetSelectedItems } from 'store/Library/actions'
import { setCurrentTab } from 'store/Library/actions'
import { setFolderTitle } from 'store/Library/actions'
import { addFolder } from 'store/Library/actions'
import { setAssignSearchValue } from 'store/Library/actions'
import { setPublic } from 'store/Library/actions'

import AssignTabs from 'views/pages/AssignTabs'
import CustomModal from 'views/pages/CustomModal'
import File from 'views/pages/File'
import ThumbnailInput from './ThumbnailInput'
import ProgressiveButton from 'views/pages/ProgressiveButton'
import Search from 'views/pages/Search'

const AddFolder = (props) => {
  const location = useLocation()
  let language = props.language || {}
  const { enableCategories } = props.courseConfig

  const dispatch = useDispatch()

  const addToDrive = location.state && location.state.from === 'drive'
  const driveFolder =
    location.state && location.state.folderId ? location.state.folderId : null

  useEffect(() => {
    return () => {
      dispatch(setPublic('public'))
      dispatch(resetSelectedItems())
      dispatch(
        setCurrentTab(
          'category',
          'selectedOrgGroups',
          'groupOrgs',
          'toggleOrgGroups',
          'showSelectedOrgGroups',
          'setShowSelectedOrgGroups',
          'setHideSelectedOrgGroups',
        ),
      )
      dispatch(setAssignSearchValue(''))
      console.log('do i enter')
    }
  }, [])

  return (
    <CustomModal
      backPath={
        props.library.parentId
          ? '/library/folder/' + props.library.parentId
          : '/library'
      }
      title={'Add folder'}
      size='lg'
    >
      <ModalBody className='scrollbar'>
        <form
          id='add-folder'
          onSubmit={(e) => dispatch(addFolder(e, addToDrive, driveFolder))}
        >
          <div className='row'>
            <div className='col-12'>
              <div>
                <Input
                  type='text'
                  placeholder={
                    language.my_library
                      ? language.my_library.folder_title
                      : null
                  }
                  value={props.folderTitle}
                  onChange={(e) => dispatch(setFolderTitle(e))}
                />
              </div>
            </div>
          </div>
          <div className='row mt-2'>
            <div className='col-12'>
              <ThumbnailInput
                placeholder={
                  language.my_library
                    ? language.my_library.choose_thumbnail
                    : 'Choose thumbnail'
                }
              />
            </div>
          </div>
          {!addToDrive ? (
            <div className='row'>
              <div className='col-8 d-flex align-items-center my-4'>
                <div className='custom-control custom-radio  mr-3'>
                  <input
                    className='custom-control-input mr-2'
                    type='radio'
                    name='accessible'
                    id='set-public'
                    checked={props.library.scope === 'public'}
                    onChange={() => dispatch(setPublic('public'))}
                  />
                  <label className='custom-control-label' htmlFor='set-public'>
                    {language.my_library ? language.my_library.public : null}
                  </label>
                </div>

                <div className='custom-control custom-radio '>
                  <input
                    className='custom-control-input mr-2'
                    type='radio'
                    name='accessible'
                    id='set-private'
                    checked={props.library.scope === 'private'}
                    onChange={() => dispatch(setPublic('private'))}
                  />
                  <label className='custom-control-label' htmlFor='set-private'>
                    {language.my_library ? language.my_library.private : null}
                  </label>
                </div>
              </div>
              {props.library.scope === 'private' ? (
                <div className='col-4 mt-3'>
                  <Search
                    placeholder={
                      language.general ? language.general.search : null
                    }
                    value={props.library.assignSearchValue}
                    onChange={(event) =>
                      dispatch(setAssignSearchValue(event.target.value))
                    }
                  />
                </div>
              ) : null}
            </div>
          ) : null}

          {props.library.scope === 'private' ? (
            <div>
              <div className='d-flex my-2'>
                <Nav
                  className='nav-fill flex-column flex-sm-row col-12 p-2 rounded '
                  id='tabs-text'
                  style={{ backgroundColor: '#f6f9fc' }}
                  pills
                  role='tablist'
                >
                  <NavItem className='nav-items'>
                    <NavLink
                      aria-selected={props.library.currentTab === 'category'}
                      className={`mb-sm-3 mb-md-0 py-2  bg-transparent font-weight-bold 
																${
                                  props.library.currentTab === 'category'
                                    ? 'active-item active-link'
                                    : 'nav-item'
                                }`}
                      onClick={() =>
                        dispatch(
                          setCurrentTab(
                            'category',
                            'selectedOrgGroups',
                            'groupOrgs',
                            'toggleOrgGroups',
                            'showSelectedOrgGroups',
                            'setShowSelectedOrgGroups',
                            'setHideSelectedOrgGroups',
                          ),
                        )
                      }
                      href='#pablo'
                      role='tab'
                    >
                      {language.general
                        ? language.general.category
                        : 'Category'}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      aria-selected={props.library.currentTab === 'user'}
                      className={`mb-sm-3 mb-md-0 py-2  bg-transparent font-weight-bold 
													${
                            props.library.currentTab === 'user'
                              ? 'active-item active-link'
                              : 'nav-item'
                          }`}
                      onClick={() =>
                        dispatch(
                          setCurrentTab(
                            'user',
                            'selectedUsers',
                            'users',
                            'toggleUsers',
                            'showSelectedUsers',
                            'setShowSelectedUsers',
                            'setHideSelectedUsers',
                          ),
                        )
                      }
                      href='#pablo'
                      role='tab'
                      color='none'
                    >
                      {language.general ? language.general.users : 'Users'}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      aria-selected={
                        props.library.currentTab === 'location-group'
                      }
                      className={`mb-sm-3 mb-md-0 py-2  bg-transparent font-weight-bold 
																${
                                  props.library.currentTab === 'location-group'
                                    ? 'active-item active-link'
                                    : 'nav-item'
                                }`}
                      onClick={() =>
                        dispatch(
                          setCurrentTab(
                            'location-group',
                            'selectedLocationGroups',
                            'locationGroups',
                            'toggleLocationGroups',
                            'showSelectedLocationGroups',
                            'setShowSelectedLocationGroups',
                            'setHideSelectedLocationGroups',
                          ),
                        )
                      }
                      href='#pablo'
                      role='tab'
                    >
                      {language.general
                        ? language.general.location_categories
                        : 'Location Groups'}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      aria-selected={props.library.currentTab === 'stores'}
                      className={`mb-sm-3 mb-md-0 py-2  bg-transparent font-weight-bold 
													${
                            props.library.currentTab === 'stores'
                              ? 'active-item active-link'
                              : 'nav-item'
                          }`}
                      onClick={() =>
                        dispatch(
                          setCurrentTab(
                            'stores',
                            'selectedStores',
                            'stores',
                            'toggleStores',
                            'showSelectedStores',
                            'setShowSelectedStores',
                            'setHideSelectedStores',
                          ),
                        )
                      }
                      href='#pablo'
                      role='tab'
                    >
                      {language.settings
                        ? language.settings.location
                        : 'Location'}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      aria-selected={props.library.currentTab === 'job-title'}
                      className={`mb-sm-3 mb-md-0 py-2 bg-transparent font-weight-bold 
																${
                                  props.library.currentTab === 'job-title'
                                    ? 'active-item active-link'
                                    : 'nav-item'
                                }`}
                      onClick={() =>
                        dispatch(
                          setCurrentTab(
                            'job-title',
                            'selectedRoles',
                            'roles',
                            'toggleRoles',
                            'showSelectedRoles',
                            'setShowSelectedRoles',
                            'setHideSelectedRoles',
                          ),
                        )
                      }
                      href='#pablo'
                      role='tab'
                    >
                      {language.settings
                        ? language.settings.assign_job_title
                        : 'Job Title'}
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
              <AssignTabs
                items={props[props.library.currentItems]}
                toggleItem={props[props.library.currentToggleFunction]}
                selectedItems={props.library.currentSelectedItems}
                mainProps={props.library}
                assignSearchValue={props.library.assignSearchValue}
                setHideSelectedItems={
                  props[props.library.currentHideSelectedItemsFunction]
                }
                setShowSelectedItems={
                  props[props.library.currentShowSelectedItemsFunction]
                }
                showSelectedItems={
                  props.library[props.library.currentShowSelectedItems]
                }
                language={props.language}
                resetSelectedItems={() => dispatch(resetSelectedItems())}
                setCurrentTab={setCurrentTab}
                setAssignSearchValue={(event) =>
                  dispatch(setAssignSearchValue(event.target.value))
                }
                setPublic={(val) => dispatch(setPublic(val))}
                enableCategories={enableCategories}
              />
            </div>
          ) : null}
        </form>
      </ModalBody>
      <ModalFooter className='py-3 border-top'>
        <ProgressiveButton
          percent={props.library.libraryUploadPercent}
          status={props.library.fileUploadStatus}
          placeholder={language.general ? language.general.submit : null}
          language={props.language}
          form='add-folder'
          type='submit'
        />
        <Link
          to={
            props.library.parentId
              ? '/library/folder/' + props.library.parentId
              : '/library'
          }
          className='btn py-2 btn-transparent active-link'
        >
          {language.general ? language.general.cancel : null}
        </Link>
      </ModalFooter>
    </CustomModal>
  )
}

export default AddFolder
